export default __webpack_public_path__ + "static/media/SourceSansProLight.981867e0.ttf";